export default __webpack_public_path__ + "static/media/lightningreflexes.20eadcdc.png";